export default "__VITE_ASSET__tdox5Rlw__"